import { _get } from "../../../../apiClient";
import config from "../../../../config";
import { _showToast } from "../../../../toastHelper";

export default async function FetchAndBindData(websiteId, sections) {
    let websiteData = await getData(websiteId);
    if (websiteData) {
        let data = JSON.parse(websiteData.jsonData);
        sessionStorage.setItem("websiteData", websiteData.jsonData)
        for (const section of sections) {
            if (section.sectionname == "seo") {
                bindSeoDetails(section, data);
            }
            else if (section.sectionname == "about") {
                bindAbout(section, data);
            }
            else if (section.sectionname == "services") {
                bindServices(section, data);
            }
            else if (section.sectionname == "gallery") {
                bindGallery(section, data);
            }
            else if (section.sectionname == "studio") {
                section.data = data.studioId;
                section.isValid = true;
            }
            else if (section.sectionname == "theme") {
                bindThemeData(section, data);
            }
        }

        return {
            sections: sections,
            websiteId: websiteId,
            eventCode: websiteData.eventCode
        };
    }
    return null;

}

const getData = async (websiteId) => {
    return await _get("/profile-pages/" + websiteId)
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return null;
        })
}

const bindSeoDetails = async (section, data) => {
    section.data = {
        title: data.seo.title,
        description: data.seo.description,
        keywords: data.seo.keywords,
        imageKey: data.seo.imageKey,
        imageFile: null,
        image: data.seo.imageKey ? config.imagesbaseurl + data.seo.imageKey : null
    }
    section.isValid = true;
}
const bindAbout = async (section, data) => {
    section.data = {
        description: data.about.description,
        featuredTitle: data.about.featuredTitle,
        featuredDescription: data.about.featuredDescription,
        imageKey: data.about.imageKey,
        imageFile: null,
        image: data.about.imageKey ? config.imagesbaseurl + data.about.imageKey : null,
    }

    section.isValid = true;
}



const bindServices = async (section, data) => {

    let services = [];
    for (const service of data.services) {
        services.push({
            title: service.title,
            description: service.description,
            serviceLink: service.serviceLink
        });
    }
    section.data = services;
    section.isValid = true;
}


const bindGallery = async (section, data) => {
    let gallery = [];
    for (const galleryItem of data.gallery) {
        gallery.push({
            fileId: galleryItem.fileId,
            name: galleryItem.name,
            image: galleryItem.imageKey ? config.imagesbaseurl + galleryItem.imageKey : null,
            imageKey: galleryItem.imageKey,
            imageFile: null,
            type: galleryItem.type,
            videoUrl: galleryItem.videoUrl,
            videoImage: galleryItem.videoImage,
            isPrimaryVideo: galleryItem.isPrimaryVideo ?? false
        });
    }
    section.data = gallery;
    section.isValid = true;
}

const bindThemeData = async (section, data) => {
    let sliders = [];
    for (const slider of data.sliders) {
        sliders.push({
            image: slider.imageKey ? config.imagesbaseurl + slider.imageKey : null,
            imageFile: null,
            imageKey: slider.imageKey
        })
    }
    section.data = sliders;
    section.isValid = true;
}